export default __webpack_public_path__ + "static/media/404-error.5950dcf6.svg";